module.exports = __webpack_public_path__ + "static/media/Gourmet-By-Vadilal.8b1078ce.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/Gourmet-By-Vadilal.gif
// module id = 308
// module chunks = 0